import {useState} from "@wordpress/element";
import {useDispatch} from "@wordpress/data";
import { decodeEntities } from '@wordpress/html-entities';
const {cartStore} = window.wc.wcBlocksData;

export default function ApplyCoupon() { 

	const [toggled, setToggled] = useState(false);
	const [couponCode, setCouponCode] = useState('');
	const [error, setError] = useState(false);
	const { applyCoupon } = useDispatch(cartStore);

	const handleApplyCoupon = async () => {
		if ( couponCode.trim() === '' ) {
			return;
		}

		// Apply coupon.
		try {
			const res = await applyCoupon(couponCode.trim());
		} catch (error) {

			// Make sure message is readable.
			const message = decodeEntities(
				error.message ?? 'Unable to apply coupon.'
			);

			// Visual to show the coupon was invalid.
			setError(message );
			console.error(message);

			// Clear error after 5s.
			setTimeout(() => { setError(false) }, 5000);
		}
	}

	return (
		<div className="zapc-checkout-coupon-apply">
			{ toggled && (
				<div
					className={
						error
							? "zapc-checkout-coupon-apply-form error"
							: "zapc-checkout-coupon-apply-form"
					}
				>
					<input type="text" placeholder="Coupon Code" value={couponCode} onChange={ (e) => { setCouponCode(e.target.value) }} />
					<button type="button" onClick={handleApplyCoupon}>Apply</button>
				</div>
			) }
			{ ! toggled && (
				<button type="button" className="zapc-checkout-coupon-apply-button" onClick={ () => { setToggled( true ) } }><i className="fa fa-plus"></i> Add Coupon</button>
			) }
			{ error && <div className="zapc-checkout-coupon-apply-error">{error}</div> }
		</div>
	);
}